
'use client'
import {
    BrowserRouter as Router,

    Route,
    Outlet,
    Routes,
    Link,
    useNavigate,
    NavLink
  } from "react-router-dom";
import {
  IconButton,
  Avatar,
  Box,
  CloseButton,
  Flex,
  HStack,
  VStack,
  Icon,
  useColorModeValue,
  Text,
  Drawer,
  DrawerContent,
  useDisclosure,
  BoxProps,
  FlexProps,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Image,
} from '@chakra-ui/react'
import {
  FiHome,
  FiTrendingUp,
  FiCompass,
  FiStar,
  FiSettings,
   FiChevronsUp,
  FiMenu,
  FiList ,
  FiBell,
  FiSquare ,
  FiDollarSign,
  FiUsers ,
  FiClock ,
  FiChevronDown,FiDatabase,FiCheckSquare ,
} from 'react-icons/fi'
import { IconType } from 'react-icons'
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from 'react-query'
import logo from '../../assets/eba836181a8bb389cc40f37585eec6ae.png'
import { GetData } from "../../api/apiFactory";

import Cookies from 'js-cookie';
import ProtectedRoute from "../../context/ProtectedRoute";
import ProtectedButton from "../../context/ProtectedButton";
import { getRefundRequests, getRefundRequestspending,getallnotifications } from "../../services/refundService";

const LinkItems = [
  // { path:'/api/v1/auth/get',method:'GET', name: 'Home', icon: FiHome ,href: '/dashboard/home' },
  {  path:'/api/v1/auth/get',method:'GET',name: 'Users', icon: FiUsers  ,href: '/dashboard/admin/users' },
  {  path:'/api/v1/categories',method:'GET', name: 'Payments', icon: FiDollarSign ,href: '/dashboard/admin/payment' },

  {  path:'/api/v1/categories',method:'GET', name: 'Deposits', icon: FiDollarSign ,href: '/dashboard/admin/deposit' },
  {  path:'/api/v1/categories',method:'GET',name: 'filesbook', icon: FiDollarSign ,href: '/dashboard/admin/filesbooking' },
  {  path:'/api/v1/categories',method:'GET',name: 'walletcharger', icon: FiDollarSign ,href: '/dashboard/admin/walletcharger' },
  {  path:'/api/v1/categories',method:'GET',name: 'Wallet Controller', icon: FiDollarSign ,href: '/dashboard/admin/wallettransaction' },
  {  path:'/api/v1/categories',method:'GET',name: 'Payment Information', icon: FiDollarSign ,href: '/dashboard/admin/paymentinfo' },
  { path:'/api/v1/categories',method:'GET', name: 'Categotries', icon: FiTrendingUp ,href: '/dashboard/admin/categories' },
  {  path:'/api/v1/categories',method:'GET',name: 'AddPermissionsfordev', icon: FiChevronsUp ,href: '/dashboard/admin/permissions' },
  
  { path:'/api/v1/categories',method:'GET', name: 'Admin List', icon: FiList  ,href: '/dashboard/admin/admin-list' },
  {  path:'/api/v1/categories',method:'GET',name: 'Admins Permissions', icon: FiCompass ,href: '/dashboard/admin/admin-permissions' },
 
  { name: 'Setting', icon: FiSettings  ,href: '/dashboard/admin/setting' },
  {  path:'/api/v1/categories',method:'GET',name: 'Ended-Auctions', icon: FiClock  ,href: '/dashboard/admin/ended-auctions' },
  {  path:'/api/v1/categories',method:'GET',name: 'Splash Screen list', icon: FiList ,href: '/dashboard/admin/splashlist' },
  {  path:'/api/v1/categories',method:'GET',name: 'Add Splash', icon: FiSquare ,href: '/dashboard/admin/splash' },
  { path:'/api/v1/categories',method:'GET', name: 'Send Notification', icon: FiBell ,href: '/dashboard/admin/notifications' },

  {  path:'/api/v1/categories',method:'GET', name: 'notifications', icon: FiBell ,href: '/dashboard/admin/notificationsadmin' },

  // { name: 'Lots', icon: FiTrendingUp ,href: '/dashboard/admin/items' },
  {  path:'/api/v1/categories',method:'GET',name: 'test place bid', icon: FiCheckSquare ,href: '/testbiding' },





  // { name: 'Trending', icon: FiTrendingUp },
  // { name: 'Explore', icon: FiCompass },
  // { name: 'Favourites', icon: FiStar },
  // { name: 'Settings', icon: FiSettings },
]

// const SidebarContent = ({ onClose, ...rest }) => {
//   return (
//     <Box
//       transition="3s ease"
//       bg={useColorModeValue('white', 'gray.900')}
//       borderRight="1px"
//       borderRightColor={useColorModeValue('gray.200', 'gray.700')}
//       w={{ base: 'full', md: 60 }}
//       pos="fixed"
//       h="full"
//       {...rest}>
//       <Flex h="20" alignItems="center" mx="8" justifyContent="space-between">
//         {/* <Text fontSize="2xl" fontFamily="monospace" fontWeight="bold">
//           Logo
//         </Text> */}

// <Box my={'10px'} >        <Image
//           alt={'Login Image'}
//           objectFit={'cover'}
//           width={{base: '25%', md:'60%'}}
//           height={'80%'}
//           src={
//            logo
        
//           }
//         /></Box>
//         <CloseButton display={{ base: 'flex', md: 'none' }} onClick={onClose} />
//       </Flex>
//       {LinkItems.map((link) => (
//         <NavItem as={Link} to={link.href} key={link.name} icon={link.icon}>
//           {link.name}
//         </NavItem>
//       ))}
//     </Box>
//   )
// }

const SidebarContent = ({ onClose, ...rest }) => {
  return (
    <Box
      transition="3s ease"
      bg={useColorModeValue('white', 'gray.900')}
      borderRight="1px"
      borderRightColor={useColorModeValue('gray.200', 'gray.700')}
      w={{ base: 'full', md: 60 }}
      pos="fixed"
      h="full"
      overflowY="auto"
      {...rest}
    >
      <Flex h="20" alignItems="center" mx="8" justifyContent="space-between">
        <Box my="10px">
          <Image
            alt="Logo"
            objectFit="cover"
            width={{ base: '25%', md: '60%' }}
            height="80%"
            src={logo}
          />
        </Box>
        <CloseButton display={{ base: 'flex', md: 'none' }} onClick={onClose} />
      </Flex>
      {LinkItems.map((link) => (
        // <ProtectedButton  method={link.method} endpoint={link.path}>  
      
        <NavItem as={Link} to={link.href} key={link.name} icon={link.icon}>
          {link.name}
        </NavItem>
        //  </ProtectedButton>  


      ))}
    </Box>
  );
};
const NavItem = ({ icon, children, ...rest }) => {
  return (
    <Box
      as="a"
      href="#"
      style={{ textDecoration: 'none' }}
      _focus={{ boxShadow: 'none' }}>
      <Flex
        align="center"
        p="4"
        mx="4"
        borderRadius="lg"
        role="group"
        cursor="pointer"
        _hover={{
          bg: 'cyan.400',
          color: 'white',
        }}
        {...rest}>
        {icon && (
          <Icon
            mr="4"
            fontSize="16"
            _groupHover={{
              color: 'white',
            }}
            as={icon}
          />
        )}
        {children}
      </Flex>
    </Box>
  )
}

const MobileNav = ({status,user, onOpen, ...rest }) => {
  const navigate = useNavigate();
  const signOut = () => {
    Cookies.remove('token'); 
    Cookies.remove('user');  // Remove the auth cookie (replace 'authToken' with your cookie name)
     // Remove the auth cookie (replace 'authToken' with your cookie name)
     window.location.href = '/auth/login'; // Replace '/auth/login' with your login page URL

     return        ;
  };
  const { data, error, isLoading } = useQuery('getallnotifications', getallnotifications);
console.log(data);

  return (
    <Flex
      ml={{ base: 0, md: 60 }}
      px={{ base: 4, md: 4 }}
      height="20"
      alignItems="center"
      bg={useColorModeValue('white', 'gray.900')}
      borderBottomWidth="1px"
      borderBottomColor={useColorModeValue('gray.200', 'gray.700')}
      justifyContent={{ base: 'space-between', md: 'flex-end' }}
      {...rest}>
      <IconButton
        display={{ base: 'flex', md: 'none' }}
        onClick={onOpen}
        variant="outline"
        aria-label="open menu"
        icon={<FiMenu />}
      />

      <Box width={'40%'} display={{ base: 'flex', md: 'none' }}>
        <Image
          alt={'Login Image'}
          objectFit={'cover'}
          width={'50%'}
          m={'auto'}
          src={logo}
        />
      </Box>
      <HStack spacing={{ base: '0', md: '6' }}>
        <NavLink to={'/dashboard/admin/refund'}>
        <IconButton      color={status?.length ? 'red' : 'blue'} size="lg" variant="ghost" aria-label="open menu" icon={<FiBell />} />
        
        </NavLink>
        <NavLink to={'/dashboard/admin/notificationsadmin'}>
        <IconButton      color={data?.length ? 'red' : 'blue'} size="lg" variant="ghost" aria-label="open menu" icon={<FiBell />} />
        
        </NavLink>
        <Flex alignItems={'center'}>
          <Menu>
            <MenuButton py={2} transition="all 0.3s" _focus={{ boxShadow: 'none' }}>
              <HStack>
                <Avatar
                  size={'sm'}
                  src={
                    'https://images.unsplash.com/photo-1619946794135-5bc917a27793?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=b616b2c5b373a80ffc9636ba24f7a4a9'
                  }
                />
                <VStack
                  display={{ base: 'none', md: 'flex' }}
                  alignItems="flex-start"
                  spacing="1px"
                  ml="2">
                  <Text fontSize="sm">{user?.username}</Text>
                  <Text fontSize="sm">{user?.email}</Text>

                  <Text fontSize="xs" color="gray.600">
                    Admin
                  </Text>
                </VStack>
                <Box display={{ base: 'none', md: 'flex' }}>
                  <FiChevronDown />
                </Box>
              </HStack>
            </MenuButton>
            <MenuList bg={useColorModeValue('white', 'gray.900')} borderColor={useColorModeValue('gray.200', 'gray.700')}>
              {/* <MenuItem>Profile</MenuItem>
              <MenuItem>Settings</MenuItem>
              <MenuItem>Billing</MenuItem> */}
              <MenuDivider />
              <MenuItem onClick={() => signOut()}>Sign out</MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </HStack>
    </Flex>
  );
};


const SideBar = ({users}) => {

  const { isOpen, onOpen, onClose } = useDisclosure()
  // const { isPending, error, data } = useQuery({
  //   queryKey: ['repoData'],
  //   queryFn: () =>
  //   GetData("/deposite?status=pending")
  // })

  const { data, error, isLoading } = useQuery('getRefundRequestspending', getRefundRequestspending);
 


  return (
    <Box minH="100vh" bg={useColorModeValue('gray.100', 'gray.900')}>
      <SidebarContent onClose={() => onClose} display={{ base: 'none', md: 'block' }} />
   
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
        size="full">
        <DrawerContent>
          <SidebarContent onClose={onClose} />
        </DrawerContent>
      </Drawer>
      {/* mobilenav */}
      <MobileNav status={data} user={users} onOpen={onOpen} />
      <Box ml={{ base: 0, md: 60 }} p="4" >
<Outlet/>
      </Box>
    </Box>
  )
}

export default SideBar